import { Box, Button } from "@mui/material";

import backgroundImage from "assets/contacts/rrhh.jpg";
import { Link } from "components/Link";
import { Title } from "components/Title";
import { rrhhPath } from "constants/routes";

export const RrhhBanner = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: { xs: "center", md: "start" },
      width: "100%",
      paddingY: "60px",
      paddingX: { xs: 3, md: 9 },
      position: "relative",
      "&::before": {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100%",
        width: "100%",
        position: "absolute",
        top: "0px",
        left: "0px",
        content: "''",
        opacity: "0.4",
      },
    }}
  >
    <Title
      style={{
        color: "rgba(1, 1, 1, .8)",
        fontSize: { xs: 30, md: 40 },
        letterSpacing: 1,
        marginBottom: 5,
        zIndex: 1,
      }}
    >
      ¿Queres trabajar en Bluecar?
    </Title>
    <Link to={rrhhPath} noMargin>
      <Button
        variant="contained"
        sx={{
          fontSize: { xs: 15, md: 20 },
          paddingX: 5,
          animation: "zoomIn 1s infinite",
          animationDirection: "alternate",
          animationTimingFunction: "ease-in-out",
        }}
      >
        Dejar mi cv
      </Button>
    </Link>
  </Box>
);
